export default () => ({
  schedules: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/active-agenda/components/consultations-made/resources/data.js